import React, { useState } from 'react';
import { IonButton, IonIcon, IonListHeader } from '@ionic/react';
import { ExploreElement } from 'models/ExploreElementModel/ExploreElementModel';
import ExploreListItem from 'components/listElements/ExploreListItem/ExploreListItem';
import Trans from 'util/Trans';
import Icon from '../../../components/icons/Icon';

interface RankingsSectionProps {
  rankings: ExploreElement[];
  activeTab: number;
  onOpenRankingModal: (element: ExploreElement) => void;
}

const RankingsSection: React.FC<RankingsSectionProps> = ({
  rankings,
  activeTab,
  onOpenRankingModal,
}) => {
  const [visibleRankingsCount, setVisibleRankingsCount] = useState(3);
  if (rankings.length === 0) return null;

  return (
    <div 
    className="section-container" 
      style={{ marginBottom: '16px', marginRight: '16px' }}
    >
      {/* Rankings Header */}
      <IonListHeader style={{ paddingLeft: '0', marginBottom: '8px' }}>
        {
          <Icon
            name="RankingIcon"
            size="default"
            color="--ion-color-primary"
            marginLeft={8}
            marginRight={4}
            style={{ backgroundColor: 'transparent' }}
          />
        }
        <Trans i18nKey="Ranking">Ranking</Trans>
        <span
          style={{
            marginLeft: '8px',
            fontSize: '12px',
            color: 'var(--ion-color-primary)',
          }}
        >
          ({rankings.length})
        </span>
      </IonListHeader>
      <div className="items-container">
        {rankings.slice(0, visibleRankingsCount).map((item, idx) => (
          <div key={`${item.id}_${idx}`} style={{ marginBottom: '4px' }}>
            <ExploreListItem
              item={item}
              isFriend={activeTab === 1}
              onOpenRankingModal={onOpenRankingModal}
            />
          </div>
        ))}

        {rankings.length > visibleRankingsCount && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '0',
              paddingTop: '0',
            }}
          >
            {/* Rankings Load More Button */}
            <IonButton
              fill="clear"
              size="small"
              className="load-more-button rankings"
              onClick={() => setVisibleRankingsCount((prev) => prev + 3)}
              style={{
                '--border-color': 'transparent',
                '--color': 'var(--ion-color-warning)',
                '--background': 'transparent',
                '--background-hover': 'var(--ion-color-warning-tint)',
                '--color-hover': 'var(--ion-color-warning-contrast)',
                boxShadow: 'none',
              }}
            >
             <Icon
                name="RankingIcon"
                size="small"
                color="--ion-color-secondary"
                marginRight={4}
                style={{ backgroundColor: 'transparent' }}
              />
              <Trans
                i18nKey="LOAD_MORE_RANKINGS"
                values={{
                  count: rankings.length - visibleRankingsCount,
                }}
              >
                {rankings.length - visibleRankingsCount} weitere Rankings
                anzeigen
              </Trans>
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default RankingsSection; 
